import {Injectable} from "@angular/core";
import {UrlBuilder} from "../url-builder/url.builder";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {FASTLINKDATA, FASTLINKLCD} from "./fastlinkstruct";

@Injectable({
  providedIn: 'root'
})
export class FastLinkDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }
  GetData(): Observable<FASTLINKDATA> {
    this.uiUrl = this.url.GetFastLinkInformationUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<FASTLINKDATA>(this.uiUrl);
  }
  SentUpdateRequest(userName: string):void {
    this.uiUrl = this.url.GetFastLinkInformationUrl() + "/create/username=" + userName ;
    console.log('FILE: ' + this.uiUrl);
    this.http.get<any>(this.uiUrl).subscribe(() => {
    });
  }

  GetLCDData(command: number): Observable<FASTLINKLCD> {
    this.uiUrl = this.url.GetFastLinkInformationUrl() + "/lcd/" + command;
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<FASTLINKLCD>(this.uiUrl);
  }


}




